module.exports = __webpack_public_path__ + "static/media/xlsDarkMode.435c00df.svg";